module.exports = __webpack_public_path__ + "static/img/doc.876251d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/doc.png
// module id = wz33
// module chunks = 3